import React, { useState } from 'react'
import { Dropdown } from '@entur/dropdown'
import { VariantType } from '@entur/form'
import { FetchState, FamilyMember } from '../../api-clients/api-types'
import { ValidationFormField } from '../../utils/form-utils'
import { useEmployee } from '../../contexts/employee-context'
import { useFamilyMembers } from '../../contexts/family-members-context'

export const ticketRightHolderFormField = (
  id?: string,
  name?: string,
  required = false
): ValidationFormField<string> => {
  return {
    value: id || '',
    displayValue: name || '',
    variant: '',
    feedback: '',
    fieldName: 'ticketRightHolder',
    displayName: 'Innehaver',
    validation: {
      required,
    },
  }
}

type DropdownItemType = {
  value: string | undefined
  label: string
}

const familyMemberToDropdownItemType = (e: FamilyMember) => {
  return { label: `${e.surname}, ${e.firstName}`, value: e.id }
}

type TicketRightHoldersDropDownProps = {
  formField: ValidationFormField<string>
  update: (value: ValidationFormField<string>) => void
  disabled?: boolean
}
const TicketRightHoldersDropDown: React.FC<TicketRightHoldersDropDownProps> = (props) => {
  const [variant] = useState(props.formField.variant)
  const [feedback] = useState(props.formField.feedback)
  const selectedItem =
    props.formField.value !== ''
      ? {
          label: props.formField.displayValue || '',
          value: props.formField.value,
        }
      : null
  const { employee } = useEmployee()
  const { familyMembersResponse } = useFamilyMembers()

  const holders =
    familyMembersResponse.status === FetchState.SUCCESS
      ? () =>
          familyMembersResponse.data
            .flatMap<DropdownItemType>(familyMemberToDropdownItemType)
            .concat([{ label: `${employee.surname}, ${employee.firstName}`, value: employee.id }])
      : [{ label: `${employee.surname}, ${employee.firstName}`, value: employee.id }]

  return (
    <Dropdown<string | undefined>
      style={{ cursor: 'pointer' }}
      label={props.formField.displayName}
      variant={variant as VariantType}
      feedback={feedback}
      items={holders}
      selectedItem={selectedItem}
      disabled={props.disabled}
      onChange={(e) => {
        if (e) {
          props.update({ ...props.formField, value: e.value || '', displayValue: e.label })
        }
      }}
    />
  )
}

export default TicketRightHoldersDropDown
